import styled from "styled-components";

export const PremiumPubEventWrapper = styled.div`
  padding: 20px 16px;
`;

export const PremiumPubEventImage = styled.div`
  margin-top: 12px;
  width: 100%;
  height: 368px;
  border-radius: 8px;

  > img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;
